const networkActionConstants = {
  GET_CONTACTS: 'GET_CONTACTS',
  SET_SEARCH: 'SET_SEARCH',
  SET_SORTBY: 'SET_SORTBY',
  GET_TAGS: 'GET_TAGS',
  GET_SYNC_DATA: 'GET_SYNC_DATA',
  TOGGLE_CONNECT_SYNC: 'TOGGLE_CONNECT_SYNC',
  DELETE_SYNC: 'DELETE_SYNC',
  UPDATE_USER_CONTACTS: 'UPDATE_USER_CONTACTS',
  SET_NETWORK_LOADING_ON: 'SET_NETWORK_LOADING_ON',
  SET_NETWORK_LOADING_OFF: 'SET_NETWORK_LOADING_OFF',
  GET_IMPORT_HISTORY: 'GET_IMPORT_HISTORY',
  GET_IMPORT_HISTORY_COUNT: 'GET_IMPORT_HISTORY_COUNT',
  DELETE_IMPORT_HISTORY: 'DELETE_IMPORT_HISTORY',
};

export default networkActionConstants;
